import React from "react";
//import styled from 'styled-components';
import { Title, Dot } from "../styles/GlobalStyles";

// const Title = styled.h1`
//   ${tw`text-4xl sm:text-6xl lg:text-7xl leading-none font-extrabold tracking-tight font-inter mb-4 text-gray-900`}
// `;
// const Dot = styled.span`
//   ${tw`text-dv2021-600`}
// `;
// const Text = styled.p`
//   ${tw`text-lg sm:text-2xl font-medium font-inter mb-2 text-gray-700`}
// `;

export default function About2() {
  return (
    <>
      <div className="bg-teal-50 pb-6">
        <section className="mx-auto max-w-screen-lg space-y-20 sm:space-y-32 md:space-y-40 lg:space-y-44 xl:max-w-screen-xl">
          <div className="mb-10 px-4 pt-10 sm:mb-16 sm:px-6 md:mb-20 md:px-8">
            <Title>
              O Dnevih varstvoslovja<Dot>.</Dot>
            </Title>
            <p className="font-inter mb-6 max-w-4xl space-y-6 text-lg font-medium text-gray-700 sm:text-2xl sm:leading-10">
              Dnevi varstvoslovja so osrednja nacionalna konferenca s področja
              varnosti. Srečanje je namenjeno vsem strokovnjakom, ki se v
              slovenski policiji, na ministrstvih za notranje zadeve, obrambo
              ali pravosodje, v carini in v ostalih delih državne uprave, v
              zasebnovarnostnih in detektivskih agencijah, v lokalnih skupnostih
              ali v gospodarskih družbah kakor koli ukvarjajo z vprašanji
              varnosti, varovanja, skratka z vsebinami, ki spadajo v okvir
              varstvoslovja. Dnevi varstvoslovja so tudi čas za srečanje
              diplomantov Univerze v Mariboru, Fakultete za varnostne vede.
            </p>
            <p className="font-inter mb-6 max-w-4xl space-y-6 text-lg font-medium text-gray-700 sm:text-2xl sm:leading-10">
              Cilj konference je predstaviti najnovejša varstvoslovna spoznanja
              in raziskovalne ugotovitve, primere dobre prakse ter primere
              uspešnih prenosov znanj v prakso, omogočiti neposreden stik med
              teoretiki in praktiki ter pospešiti razgrinjanje in reševanje
              aktualnih problemov na področju varstvoslovja.
            </p>
            <p className="font-inter mb-6 max-w-4xl space-y-6 text-lg font-medium text-gray-700 sm:text-2xl sm:leading-10">
              Na konferenci bomo tudi tokrat ponudili prostor za široko razpravo
              o zagotavljanju varnosti, zato si želimo prispevkov, ki bodo ta
              družbeni pojav naslovili v vsej njegovi kompleksnosti in
              celovitosti.
            </p>
          </div>
        </section>
      </div>
    </>
  );
}
